import type {
    AdminDomainErrorNames,
    DomainErrors,
} from "instance-management-domain";
import {
    useNotifyError as libUseNotifyError,
    type ErrorMessageMap,
} from "@for-it/web-lib";

export const errorMessages = {
    UnexpectedError: "Ocurrió un error inesperado",
    NotFoundError: "No se encontró el recurso solicitado",
    InvalidCredentialsError: "Credenciales inválidas",
    BucketOperationFailedError: "Error en la operación del bucket",
    BucketUnusableError: "El bucket no está disponible",
    InvalidSubdomainError:
        "El subdominio no es válido (solo a-z, 0-9, guiones)",
    PaymentCredentialsInvalidError: "Las credenciales de pago son inválidas",
    SubdomainAlreadyExistsError: "Ese subdominio ya está en uso",
    TenantBootstrapFailedError:
        "Error al provisionar el tenant. Revisá los logs.",
    TenantNotFoundError: "No se encontró el tenant",
    RateLimitError: "Se alcanzó el límite de solicitudes",
    ValidationError: "Hay errores en los datos ingresados",
} as const satisfies ErrorMessageMap<AdminDomainErrorNames>;

export const useNotifyError = libUseNotifyError<DomainErrors>;
